<!-- spinner.component.html -->
<div *ngIf="this.loading">
    <div class="spinner-container">
        <div class="spinner">
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </div>
        <div class="cargando">Procesando...</div>
</div>
